import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ILoginStore} from './login.stores';
import {IAppRootStore} from '../../app.root.store';
import LoginLayoutComponent from './components/layout/index';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';

interface LoginViewProps {
    loginStore: ILoginStore;
    rootStore: IAppRootStore;
}

@observer
export class LoginViewComponent extends TechseeBaseComponent<LoginViewProps> {
    renderInternal(): JSX.Element {
        return <LoginLayoutComponent />;
    }
}

export const LoginView = inject('rootStore', 'loginStore')(LoginViewComponent) as IReactComponent;
